export class UniqueVisitorRequest {
    browser: string = "";
    browserVersion: string = "";
    device: string = "";
    ipNet: string = "";
    location: string = "";
    operatingSystem: string = "";
    osVersion: string = "";
    resources: string = "";
    userAgent: string = "";
}


// WEBPACK FOOTER //
// ./src/app/shared/header/uniqueVisitorRequest.ts